export const GET_USER_MY_TEAM = "GET_USER_MY_TEAM"
export const GET_USER_MY_TEAM_SUCCESSFUL = "GET_USER_MY_TEAM_SUCCESSFUL"
export const GET_USER_MY_TEAM_FAILED = "GET_USER_MY_TEAM_FAILED"
export const UPDATE_USER_MY_TEAM = "UPDATE_USER_MY_TEAM"
export const UPDATE_USER_MY_TEAM_SUCCESSFUL = "UPDATE_USER_MY_TEAM_SUCCESSFUL"
export const UPDATE_USER_MY_TEAM_FAILED = "UPDATE_USER_MY_TEAM_FAILED"